import React from 'react';
import PropTypes from 'prop-types';
import Table, { Row, Column } from 'components/molecules/TableList';
const RoomTable = ({ rooms }) => (
  <Table zebra>
    {rooms.map(room => (
      <Row>
        <Column width="25%" heading>
          {room.unitType}
        </Column>
        <Column width="25%">{room.priceBasis}</Column>
        <Column width="25%">{room.guidePrice}</Column>
        <Column width="25%">{room.name}</Column>
      </Row>
    ))}
  </Table>
);
RoomTable.propTypes = {
  rooms: PropTypes.any,
};

export default RoomTable;
